import pathToRegexp from 'path-to-regexp';
import React from 'react';
import PropTypes from 'prop-types';
import { StringConstantsMixin } from 'react_components/mixins/shared/string_constants_mixin';
import { LanguageSupportUtil } from 'utils/language_support_util';
import useLanguageRegionCode from 'hooks/useLanguageRegionCode';
import LogoImage from 'images/icons/cuttlefish/logo.svg';
import ActiveProBadge from 'images/icons/cuttlefish/activeProBadge.svg';
import ProBadge from 'images/icons/cuttlefish/proBadge.svg';
import useUser from 'hooks/useUser';
import usePathname from 'hooks/usePathname';
import * as styles from './styles/styles.module.scss';

const {
  ALLTRAILS,
  NAVIGATION: { PRO_BADGE_ALT_TEXT }
} = StringConstantsMixin.strings;

const Logo = ({ proBadgeLink }) => {
  const languageRegionCode = useLanguageRegionCode();
  const pathname = usePathname();
  const user = useUser();

  const logoLink = LanguageSupportUtil.wrapUrlSafe('/?ref=header', languageRegionCode);

  const isProBadgeActive =
    user?.pro || (user && (pathToRegexp('/:locale?/pro').test(pathname) || pathToRegexp('/:locale?/pro/signup').test(pathname)));

  return (
    <div className={styles.container}>
      <a href={logoLink}>
        <img alt={ALLTRAILS} className={styles.logo} src={LogoImage} />
      </a>
      <a href={proBadgeLink}>
        <img alt={PRO_BADGE_ALT_TEXT} className={styles.proBadge} src={isProBadgeActive ? ActiveProBadge : ProBadge} />
      </a>
    </div>
  );
};

Logo.defaultProps = {
  proBadgeLink: null
};

Logo.propTypes = {
  proBadgeLink: PropTypes.string
};

export default Logo;
